import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function PublishAndShare() {
  const { t } = useTranslation();
  const image001 = useDocImage('publish-and-share-img', 'image001.png');
  const image002 = useDocImage('publish-and-share-img', 'image002.png');
  const image003 = useDocImage('publish-and-share-img', 'image003.jpg');
  const image004 = useDocImage('publish-and-share-img', 'image004.jpg');
  const image005 = useDocImage('publish-and-share-img', 'image005.jpg');
  const image006 = useDocImage('publish-and-share-img', 'image006.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.publishShare.title')}</h1>
              <p className='header-para'>
                {t('documentation.publishShare.intro')}
              </p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.publishShare.accessing.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>{t('documentation.publishShare.accessing.steps.step1')}
                      <img src={image001} alt={t('documentation.publishShare.accessing.imageAlt1')} className='img-fluid pb-20 pt-20' />
                    </li>
                    <li>{t('documentation.publishShare.accessing.steps.step2')} <br />
                      <img src={image002} alt={t('documentation.publishShare.accessing.imageAlt2')} className='img-fluid pt-20 pb-20' />
                    </li>

                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.publishShare.urls.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.publishShare.urls.defaultLink')}</p>
                  <img src={image003} alt={t('documentation.publishShare.urls.imageAlt1')} className='pt-10 pb-30 w-60' />

                  <p dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.createNewTitle') }}></p>
                  <ul>
                    <li>
                      {t('documentation.publishShare.urls.steps.step1')}
                      <img src={image006} alt={t('documentation.publishShare.urls.imageAlt2')} className=' pb-10' />
                    </li>
                    <li>{t('documentation.publishShare.urls.steps.step2')}</li>
                    <li>
                      {t('documentation.publishShare.urls.steps.step3')}
                      <img src={image004} alt={t('documentation.publishShare.urls.imageAlt3')} className='pt-20 pb-20' />
                    </li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.steps.step4') }}></li>
                    <li>{t('documentation.publishShare.urls.steps.step5')}</li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.steps.step6') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.steps.step7') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.steps.step8') }}></li>
                    <li>{t('documentation.publishShare.urls.steps.step9')}</li>
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.urls.steps.step10') }}></span>
                      <ul className='pt-10'>
                        <li>{t('documentation.publishShare.urls.contentExamples.example1')}</li>
                        <li>{t('documentation.publishShare.urls.contentExamples.example2')}</li>
                      </ul>
                    </li>
                    <li>{t('documentation.publishShare.urls.steps.step11')}</li>
                    <li>{t('documentation.publishShare.urls.steps.step12')}</li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.publishShare.tableListingFields.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.publishShare.tableListingFields.intro')}</p>
                  <img src={image005} alt={t('documentation.publishShare.tableListingFields.imageAlt')} className='pt-20 pb-20' />


                  <ul>

                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.tableListingFields.fields.name') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.tableListingFields.fields.response') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.tableListingFields.fields.createdDate') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.tableListingFields.fields.status') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.publishShare.tableListingFields.fields.actions') }}></li>

                  </ul>

                  <p>{t('documentation.publishShare.tableListingFields.conclusion')}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
